var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _circle2, _path11, _circle3, _path12, _circle4, _circle5, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02515IconServiceWebAppDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf881ec5-63ed-429e-80b4-212a11bccf93",
    x1: -554.03,
    y1: 1012.115,
    x2: -546,
    y2: 1012.115,
    gradientTransform: "matrix(1, 0, 0, -1, 564, 1025.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0071c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#006abb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005ba1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "eb9fa8af-e07d-44ed-b6cd-229c77c68b58",
    cx: 13739.634,
    cy: -1957.723,
    r: 33.137,
    gradientTransform: "matrix(0.15, 0, 0, -0.15, -2055.987, -288.708)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5ea0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a4ca34b6-ae97-45e7-91fe-693f497ec5fb",
    x1: -561.718,
    y1: 1019.116,
    x2: -561.736,
    y2: 1021.424,
    gradientTransform: "matrix(1, 0, 0, -1, 564, 1025.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb1611b6-9670-4726-8ce5-45c43850c56f",
    x1: -558.371,
    y1: 1016.796,
    x2: -558.371,
    y2: 1018.87,
    gradientTransform: "matrix(1, 0, 0, -1, 564, 1025.516)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc37bdd6-7d1d-440a-bfff-2014f6aa4bc9",
    x1: 8.857,
    y1: 1.834,
    x2: 8.857,
    y2: 16.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50e6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32bedd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.985,10.256c-2.218,0-4.015-.626-4.015-1.453v7.742c0,.8,1.766,1.441,3.958,1.453h.057C16.2,18,18,17.372,18,16.545V8.8C18,9.611,16.2,10.256,13.985,10.256Z",
    fill: "url(#bf881ec5-63ed-429e-80b4-212a11bccf93)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8.8c0,.808-1.8,1.453-4.015,1.453S9.97,9.63,9.97,8.8s1.8-1.453,4.015-1.453S18,7.976,18,8.8",
    fill: "#e8e8e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.067,8.684c0,.513-1.385.927-3.082.927S10.9,9.2,10.9,8.684s1.384-.921,3.082-.921,3.082.413,3.082.921",
    fill: "#50e6ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.985,8.916a7.2,7.2,0,0,0-2.437.357,7.166,7.166,0,0,0,2.437.338,7,7,0,0,0,2.436-.363A7.391,7.391,0,0,0,13.985,8.916Z",
    fill: "#198ab3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "b576462a-0f3e-4698-811f-0d2a90338812",
    d: "M8.014,8.878A4.969,4.969,0,1,1,1.925,1.024L1.977.989A4.967,4.967,0,0,1,8.014,8.878",
    fill: "url(#eb9fa8af-e07d-44ed-b6cd-229c77c68b58)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.619,3.916A7.6,7.6,0,0,1,8.826,1.824,4.954,4.954,0,0,0,7.955.983a8.35,8.35,0,0,0-2.74.643A7.317,7.317,0,0,0,2.83,3.274,1.607,1.607,0,0,1,3.619,3.916Z",
    fill: "#fff",
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.159,5.915A10.391,10.391,0,0,0,.674,7.446a4.63,4.63,0,0,0,.362.537,4.926,4.926,0,0,0,.322.38,10.42,10.42,0,0,1,.631-2.027A1.613,1.613,0,0,1,1.159,5.915Z",
    fill: "#fff",
    opacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.732,3.262a7.008,7.008,0,0,1-.4-1.718,4.727,4.727,0,0,0-.643.847,7.4,7.4,0,0,0,.333,1.391A1.569,1.569,0,0,1,1.732,3.262Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.269,
    cy: 4.764,
    r: 1.595,
    fill: "url(#a4ca34b6-ae97-45e7-91fe-693f497ec5fb)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6,7.68a1.037,1.037,0,0,1,.316-.743A6.941,6.941,0,0,1,3.432,5.851a1.6,1.6,0,0,1-.87.485,7.73,7.73,0,0,0,.847.748,7.075,7.075,0,0,0,1.2.73A1,1,0,0,1,4.6,7.68Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.277,7.8a6.95,6.95,0,0,1-1.613-.187.236.236,0,0,1,0,.065,1.023,1.023,0,0,1-.3.724,7.924,7.924,0,0,0,2,.14,4.756,4.756,0,0,0,.7-.783A6.614,6.614,0,0,1,8.277,7.8Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.629,
    cy: 7.68,
    r: 1.04,
    fill: "url(#bb1611b6-9670-4726-8ce5-45c43850c56f)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.909,4.91a1.073,1.073,0,0,1,.357-.585A14.873,14.873,0,0,1,4.659,1.906,9.887,9.887,0,0,1,3.491.2a4.341,4.341,0,0,0-.637.245A10.616,10.616,0,0,0,4.11,2.3,15.478,15.478,0,0,0,6.909,4.91Z",
    fill: "#f2f2f2",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.996,
    cy: 5.108,
    r: 1.104,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.849,5.851l-.205-.1h0l-.175-.093H9.434l-.152-.123H9.241L9.06,5.418a1.032,1.032,0,0,1-.374.538c.07.047.146.087.222.128l.047.03.2.111h0l.5.263h0a5.2,5.2,0,0,0,.169-.649Z",
    fill: "#f2f2f2",
    opacity: 0.55
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.269,
    cy: 4.764,
    r: 1.595,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.629,
    cy: 7.68,
    r: 1.04,
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9,14.986c.124,0,.246-.005.368-.012v1.2c-.122.007-.245.01-.368.01a7.2,7.2,0,0,1-7.164-6.63,5.49,5.49,0,0,0,1.3.655A6,6,0,0,0,9,14.986ZM9.548,1.834a5.546,5.546,0,0,1,.658,1.3,6.011,6.011,0,0,1,4.347,3.629,10.562,10.562,0,0,1,1.324.144A7.2,7.2,0,0,0,9.548,1.834Z",
    fill: "url(#bc37bdd6-7d1d-440a-bfff-2014f6aa4bc9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02515IconServiceWebAppDatabase);
export default __webpack_public_path__ + "static/media/02515-icon-service-Web-App-+-Database.5f9903c68d0c7007cf63f5b16a8a64fa.svg";
export { ForwardRef as ReactComponent };